import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { IconSystemV2ArrowDropdownArrowUp } from '@doltech/icons/SystemV2/IconSystemV2ArrowDropdownArrowUp';
import { colorsV2 } from '../colors-v2';
import { ResponsiveTypography } from '../Typography/v3/ResponsiveTypography';
import { ExpandCollapseAnimation } from '../../examples/Animation/ExpandCollapse';

const Content = styled.div`
  padding: 0 16px 16px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;

  padding: 8px 16px 8px 12px;
  user-select: none;
  cursor: pointer;

  .dropdown-icon {
    transform: rotate(180deg);
    transition: all 0.15s ease-out;
  }
`;

const Container = styled.div`
  background-color: ${colorsV2.neutral10};
  border-radius: 8px;

  &.expanded {
    .dropdown-icon {
      transform: rotate(0);
    }
  }
`;

interface CardQuizExplainProps {
  title?: string;
  description?: string;
}

export const CardQuizExplain = (props: CardQuizExplainProps) => {
  const { title, description } = props;
  const [expanded, setExpanded] = React.useState(true);

  return (
    <Container className={cl('card-quiz-explain', { expanded })}>
      <Header
        className="header"
        onClick={() => setExpanded((prevExpanded) => !prevExpanded)}
      >
        <IconSystemV2ArrowDropdownArrowUp className="dropdown-icon" size={24} color="neutral80" mr="8px" />
        <ResponsiveTypography.Paragraph variant="semi-bold/16-24" color="neutral180">
          {title}
        </ResponsiveTypography.Paragraph>
      </Header>
      <ExpandCollapseAnimation expanded={expanded}>
        <Content>
          <ResponsiveTypography.Paragraph variant="regular/16-28" color="neutral180">
            {description}
          </ResponsiveTypography.Paragraph>
        </Content>
      </ExpandCollapseAnimation>
    </Container>
  );
};
